import axios from "axios";
import {
  ORDER_HISTORY, PAGE_LOAD, SET_HOME_SKELETON, SET_TOTAL_ORDERS, TOTAL_ORDERS_LOADER_START, TRACK_ORDER
} from "./types";

// Home page shows a skeleton (instead of the global dotted loader) until its first menu load finishes
export const setHomeSkeleton = (show) => ({
  type: SET_HOME_SKELETON,
  payload: show
});

export const orderHistory = (pageNumber = 1, limit = 10, searchValue = "") => (dispatch) => {
  let data = {
    business_id: localStorage.business_id,
    location_id: localStorage.location_id,
    contact_id: localStorage.headers != undefined ? (JSON.parse(localStorage.headers)?.data?.user?.contact_id) : 0,
    page: pageNumber,
    offset: (pageNumber - 1) * limit,
    limit: limit
  }
   if (searchValue) {
      data.search = searchValue;
    }
  dispatch({
    type: PAGE_LOAD
  })
  dispatch({
    type: TOTAL_ORDERS_LOADER_START,
    loader: true
  });
  axios
    .post("/track_order_history", data)
    .then((response) => {
              const sells = response.data.sells || [];

        // ✅ Filter by invoice number if searchValue exists
        const filtered = searchValue
          ? sells.filter(
              (item) =>
                item.invoice_no &&
                item.invoice_no
                  .toString()
                  .toLowerCase()
                  .includes(searchValue.toLowerCase())
            )
          : sells;
      dispatch({
        type: ORDER_HISTORY,
        payload: filtered,
      });
      if (response.data.total !== undefined) {
        dispatch({
          type: SET_TOTAL_ORDERS,
          payload: response.data.total,
          loader: false
        });
      }
    }).catch((err) => {
      // dispatch(getError(err))
    })
}

export const trackOrder = (load = true) => (dispatch) => {
  console.log(localStorage.getItem("business_id"))

  let data = {
    business_id: localStorage.getItem('business_id'),
    location_id: localStorage.getItem('location_id'),
    contact_id: localStorage.headers != undefined ? (JSON.parse(localStorage.headers)?.data?.user?.contact_id) : 0
  }

  if (load) {
    dispatch({
      type: PAGE_LOAD
    })
  }


  axios.post("/track_order", data).then((response) => {
    dispatch({
      type: TRACK_ORDER,
      payload: response.data.sells,
      loading: false
    })
  })
}